define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.indexOf;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/indexOf.js
 ** module id = 193
 ** module chunks = 0
 **/